<template>
  <div>
    <template>
      <v-tabs
        v-model="tab"
        background-color="blue-grey lighten-1"
        centered
        dark
      >
        <v-tabs-slider></v-tabs-slider>

        <v-tab href="#tab-1">
          Dynamic
        </v-tab>

        <v-tab href="#tab-2">
          Static
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-1">
          <WorkshopDashboard />
        </v-tab-item>
        <v-tab-item value="tab-2">
          <WorkshopDashboardStatic />
        </v-tab-item>
      </v-tabs-items>
    </template>
  </div>
</template>

<script>
import WorkshopDashboard from "../components/WorkshopDashboard";
import WorkshopDashboardStatic from "../components/WorkshopDashboardStatic";
import DefaultLayout from "@/layouts/DefaultLayout";

export default {
  name: "Workshop",
  created() {
    this.$emit(`update:layout`, DefaultLayout);
  },
  components: {
    WorkshopDashboard,
    WorkshopDashboardStatic,
  },
  data() {
    return {
      tab: null,
    };
  },
};
</script>